// extracted by mini-css-extract-plugin
module.exports = {"comments":"Comments_comments__oeHoP","comment":"Comments_comment__22akm","endpoint":"Comments_endpoint__26S7B","sub":"Comments_sub__1z7z6","close":"Comments_close__1IODX"};